export type CheckState = 'pending' | 'running' | 'ok' | 'error';

export type AuthMethod = 'naa-silent' | 'naa-interactive' | 'none';

export interface GraphUser {
  displayName: string;
  mail: string;
  userPrincipalName: string;
}

export interface AppStatus {
  officeReady: CheckState;
  auth: CheckState;
  authMethod: AuthMethod;
  user: CheckState;
  onedrive: CheckState;
  folder: CheckState;
  folderAction: 'none' | 'exists' | 'created';
  graphUser: GraphUser | null;
  error: string | null;
  errorDetail: string | null;
}

export const initialStatus = (): AppStatus => ({
  officeReady: 'pending',
  auth: 'pending',
  authMethod: 'none',
  user: 'pending',
  onedrive: 'pending',
  folder: 'pending',
  folderAction: 'none',
  graphUser: null,
  error: null,
  errorDetail: null,
});

export type Phase2View = 'booting' | 'setup' | 'main' | 'signing' | 'error';

export type SigningSession = {
  attachmentId: string;
  fileName: string;
  kind: 'pdf' | 'docx';
  documentBytes: Uint8Array;
};
